import { Map } from 'immutable';
import { nanoid } from 'nanoid';
import { RootHelper } from './Root';
export var ContentFragmentType;
(function (ContentFragmentType) {
    ContentFragmentType[ContentFragmentType["Root"] = 0] = "Root";
    ContentFragmentType[ContentFragmentType["Section"] = 1] = "Section";
    ContentFragmentType[ContentFragmentType["Column"] = 2] = "Column";
    ContentFragmentType[ContentFragmentType["Widget"] = 3] = "Widget";
})(ContentFragmentType || (ContentFragmentType = {}));
export const createNewContent = () => {
    const rootId = nanoid();
    const root = RootHelper.build(rootId, []);
    return createContent(rootId, [root]);
};
export const createContent = (rootId, fragments) => {
    const fragmentsById = Map(fragments.map((fragment) => [fragment._id, fragment]));
    return {
        rootId,
        fragmentsById,
    };
};
